var ObjectHelper = {
  isEmpty : function ( obj ) {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  },

  clone : function ( obj ) {
    return jQuery.extend ( true, {}, obj );
  },
};
